// ProductNameQuestion.jsx
import React from "react";
import PerlTextField from "../../components/PerlTextField";
import PerlLabelMedium from "../../components/PerlLabelMedium";

/**
 * ProductNameQuestion - Shared question component
 * Used by: F&B, Mechanical, Electronics, Packaging
 *
 * Reusable question component for product/part name input
 */
export default function ProductNameQuestion({
  value,
  onChange,
  error,
  success,
  labelText,
  placeHolderText = "",
  onAutoAdvance, // Auto-advance handler from ChatInterface
  autoAdvanceOnBlur = false, // Enable auto-advance on blur
}) {
  const handleBlur = () => {
    if (autoAdvanceOnBlur && onAutoAdvance && value && value.trim() && !error) {
      onAutoAdvance();
    }
  };

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>{labelText}</PerlLabelMedium>
      <PerlTextField
        fullWidth
        placeholder={placeHolderText || ""}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        error={Boolean(error)}
        helperText={error}
      />
      {success && (
        <PerlLabelMedium sx={{ mt: 1, color: "success.main" }}>{success}</PerlLabelMedium>
      )}
    </>
  );
}
